"use client"

import { useState } from "react"
import {
    RegistrationFormValues,
    UseRegistrationFormOptions,
    UseRegistrationFormReturn,
} from "../types"

export const useRegistrationForm = ({
    form,
    onResetIcoData,
}: UseRegistrationFormOptions): UseRegistrationFormReturn => {
    const [loading, setLoading] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [isMessageSent, setIsMessageSent] = useState(false)

    const handleSubmit = async (values: RegistrationFormValues): Promise<void> => {
        try {
            setLoading(true)

            // Lưu nhà cung cấp + gửi mail xác nhận cho họ (server lo hết)
            const response = await fetch("/api/supplier-registration", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    fullname: values.fullname,
                    position: values.position,
                    companyName: values.companyName,
                    ico: values.ico,
                    dic: values.dic,
                    phoneNumber: values.phone,
                    email: values.email,
                    companyAddress: values.address,
                    note: values.notes,
                }),
            })

            if (!response.ok) {
                throw new Error("Failed to submit supplier registration")
            }

            setIsMessageSent(true)
            form.resetFields()
            onResetIcoData()
        } catch (e) {
            console.error(e)
            setIsMessageSent(false)
        } finally {
            setLoading(false)
            setShowAlert(true)
        }
    }

    const closeAlert = () => {
        setShowAlert(false)
    }

    return {
        loading,
        showAlert,
        isMessageSent,
        handleSubmit,
        closeAlert,
    }
}

